
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NonEditableLayoutEditor',
  props: {
    layoutDataEdit: {
      type: Object,
      default: () => ({})
    },
    layoutDisbabled: {
      type: Boolean,
      default: false
    },
    playSoundEdit: {
      type: Boolean,
      default: false
    },
    layoutType: {
      type: String,
      default: ''
    },
    signageAssets: {
      type: Array,
      default: () => []
    },
    isCreatingNewSignageItem: {
      type: Boolean,
      default: false
    }
  },
  emits: ['updatePlaySound', 'updateLayoutData']
});
